import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_0f4a7391863367033d8fa631a5b83bf4/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from 'emotion';
import Cookies from 'js-cookie';
import { queryAccountType } from '../../../apis/partnerApi';
import { isLogin } from '../../../common/userState';
import { confirm } from '../components/Modal';
import { COMPANY_APPLY_URL } from '../constants';
import { t, Trans } from '../i18n/ns/common';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    &.c-dialog {\n      position: fixed;\n      width: 564px;\n    }\n    .c-dialog-confirm {\n      padding: 48px 23px 12px 23px;\n      max-width: 564px;\n    }\n    .c-dialog-confirm-title {\n      font-size: 24px;\n      line-height: 34px;\n      margin-bottom: 24px;\n    }\n    .c-dialog-confirm-desc {\n      font-size: 18px;\n      line-height: 24px;\n      color: #000;\n    }\n    .c-dialog-ft-btn-sumbit {\n      font-size: 16px;\n      line-height: 48px;\n      height: 48px;\n      background: #006eff;\n      border-radius: 4px;\n      border-color: #006eff;\n      text-align: center;\n    }\n    .c-dialog-ft-btn-cancle {\n      display: none;\n    }\n    .c-dialog-ft {\n      padding-bottom: 58px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var applyNowModal = {
    wrapClass: css(_templateObject())
};
export function checkAccountType() {
    return _checkAccountType.apply(this, arguments);
}
function _checkAccountType() {
    _checkAccountType = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var uin, skey, resp;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return isLogin(false);
                case 2:
                    if (!_ctx.sent) {
                        _ctx.next = 20;
                        break;
                    }
                    uin = parseInt(String(Cookies.get('uin') || '').replace(/^o0*/, ''), 10);
                    skey = Cookies.get('skey') || '';
                    _ctx.next = 7;
                    return queryAccountType(uin, skey);
                case 7:
                    resp = _ctx.sent;
                    if (!(resp.code === 1001)) {
                        _ctx.next = 11;
                        break;
                    }
                    location.href = "".concat(location.origin, "/login?from=partner&s_url=").concat(encodeURIComponent(COMPANY_APPLY_URL));
                    return _ctx.abrupt("return");
                case 11:
                    if (!(resp.code !== 0 && resp.code !== 1003)) {
                        _ctx.next = 14;
                        break;
                    }
                    confirm({
                        title: t('Note'),
                        wrapClass: applyNowModal.wrapClass,
                        content: /*#__PURE__*/ _jsx("p", {
                            children: /*#__PURE__*/ _jsx(Trans, {
                                children: "System Error"
                            })
                        })
                    });
                    return _ctx.abrupt("return");
                case 14:
                    if (!(resp.code === 1001)) {
                        _ctx.next = 17;
                        break;
                    }
                    location.href = "".concat(location.origin, "/login?from=partner&s_url=").concat(encodeURIComponent(COMPANY_APPLY_URL));
                    return _ctx.abrupt("return");
                case 17:
                    // 删除账号类型校验
                    // if (resp.data?.account_type !== 2) {
                    //   confirm({
                    //     title: t('Enterprise account required'),
                    //     wrapClass: applyNowModal.wrapClass,
                    //     content: (
                    //       <p>
                    //         <Trans>
                    //           To become a Tencent Cloud partner, you need to use a Tencent Cloud enterprise account.
                    // Sign up for for an
                    //           enterprise account now?
                    //         </Trans>
                    //       </p>
                    //     ),
                    //     btnOkMsg: <Trans>Sign Up Now</Trans>,
                    //     onOk() {
                    //       window.location.href = '/account/register/partner';
                    //     },
                    //   });
                    //   return;
                    // }
                    window.location.href = '/account/partners/companyApplyInfo/index';
                    _ctx.next = 21;
                    break;
                case 20:
                    {
                        window.location.href = "/account/login?from=partner&s_url=".concat(encodeURIComponent(COMPANY_APPLY_URL));
                    }
                case 21:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _checkAccountType.apply(this, arguments);
}
if ("object" !== 'undefined') {
    window.checkAccountType = checkAccountType;
}
